import { render, staticRenderFns } from "./BlogPostPlaceholder.vue?vue&type=template&id=0d7036c9&"
var script = {}
import style0 from "./BlogPostPlaceholder.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports